import { type FC } from 'react';
import { Flex, LoadingDots } from '@highereducation/hen-ui';
import PiiConfirmation from '../PiiConfirmation/Default';
import ProgramSelect from '../ProgramSelect/Default';
import ExitStrategy from '../ExitStrategy/Recommender';
import AdditionalQuestions from '../AdditionalQuestions';
import type { RecommenderProps } from './types';
import Recommender from './index';

const SubmissionLoader: FC = () => (
  <Flex
    align='center'
    justify='center'
    className='not-prose relative h-full min-h-[60vh] w-full rounded-2xl bg-white'
  >
    <LoadingDots label='Submitting request' color='secondary' />
  </Flex>
);

const RecommenderDefault: FC<RecommenderProps> = (props) => (
  <Recommender
    AdditionalQuestionsComponent={AdditionalQuestions}
    programSelectComponent={ProgramSelect}
    PiiConfirmationComponent={PiiConfirmation}
    SubmissionComponent={SubmissionLoader}
    ExitStrategyComponent={ExitStrategy}
    {...props}
  />
);

export default RecommenderDefault;
